// ─────────────────────────────────────────────────────────────────
// Glass-i — interlayer roll/kg → m² conversion (frontend preview).
//
// Mirrors backend itemInterlayerSpecs.conversion — pure, side-effect-free, so
// the Add/Edit modal can show a live "≈ X m²/roll" hint. The backend stays
// authoritative for stored values; this only powers the on-screen preview.
//
//   area per roll (m²) = roll_width_mm/1000 × roll_length_m
//   rolls → m²         = rolls × area-per-roll
//   kg    → m²         = kg ÷ kg_per_sqm
// ─────────────────────────────────────────────────────────────────

function num(v) {
  if (v === null || v === undefined || v === '') return 0;
  const n = Number(v);
  return Number.isFinite(n) ? n : 0;
}
function round3(v) {
  const n = Number(v);
  return Number.isFinite(n) ? Math.round(n * 1000) / 1000 : 0;
}

// m² in one full roll; null when the roll size is not fully specified.
export function sqmPerRoll(rollWidthMm, rollLengthM) {
  const w = num(rollWidthMm);
  const l = num(rollLengthM);
  if (!(w > 0) || !(l > 0)) return null;
  return round3((w / 1000) * l);
}

export function rollsToSqm(rolls, rollWidthMm, rollLengthM) {
  const per = sqmPerRoll(rollWidthMm, rollLengthM);
  if (per === null) return null;
  return round3(num(rolls) * per);
}

export function kgToSqm(kg, kgPerSqm) {
  const f = num(kgPerSqm);
  if (!(f > 0)) return null;
  return round3(num(kg) / f);
}

// Area (m²) display — 3 dp, Indian grouping (rule 5A).
const NF3 = new Intl.NumberFormat('en-IN', { minimumFractionDigits: 3, maximumFractionDigits: 3 });
export function formatSqm(v) {
  if (v === null || v === undefined || v === '') return '—';
  const n = Number(v);
  return Number.isFinite(n) ? NF3.format(n) : '—';
}

export const INTERLAYER_TYPE_OPTIONS = [
  { value: 'pvb', label: 'PVB' },
  { value: 'eva', label: 'EVA' },
  { value: 'sgp', label: 'SGP (ionoplast)' },
  { value: 'tpu', label: 'TPU' },
  { value: 'other', label: 'Other' }
];
